// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var PlacedFrom;
(function (PlacedFrom) {
    // last upd in #111940
    PlacedFrom[PlacedFrom["OTHER"] = 0] = "OTHER";
    PlacedFrom[PlacedFrom["TABLE_ALERT"] = 1] = "TABLE_ALERT";
    PlacedFrom[PlacedFrom["CUSTOM_COLUMN_BTN_SCRIPT"] = 2] = "CUSTOM_COLUMN_BTN_SCRIPT";
    PlacedFrom[PlacedFrom["SDK"] = 3] = "SDK";
    PlacedFrom[PlacedFrom["OE"] = 4] = "OE";
    // FXBOARD = 5, // c 2017 года была удалена
    PlacedFrom[PlacedFrom["MARKETDEPTH"] = 6] = "MARKETDEPTH";
    PlacedFrom[PlacedFrom["MATRIX"] = 7] = "MATRIX";
    PlacedFrom[PlacedFrom["CHART_OE"] = 8] = "CHART_OE";
    PlacedFrom[PlacedFrom["CHART_VISUAL"] = 9] = "CHART_VISUAL";
    // = 10, Desktop =Currency Exchange События, связанные с панелью Currency Exchange
    PlacedFrom[PlacedFrom["POSITIONS_PANEL_HOT_BTN"] = 11] = "POSITIONS_PANEL_HOT_BTN";
    PlacedFrom[PlacedFrom["POSITIONS_PANEL_DB_CLICK"] = 12] = "POSITIONS_PANEL_DB_CLICK";
    PlacedFrom[PlacedFrom["ORDERS_PANEL_HOT_BTN"] = 13] = "ORDERS_PANEL_HOT_BTN";
    PlacedFrom[PlacedFrom["ORDERS_PANEL_DB_CLICK"] = 14] = "ORDERS_PANEL_DB_CLICK";
    PlacedFrom[PlacedFrom["OPTION_MASTER"] = 15] = "OPTION_MASTER";
    PlacedFrom[PlacedFrom["SAVED_ORDERS"] = 16] = "SAVED_ORDERS";
    PlacedFrom[PlacedFrom["SCALPER"] = 17] = "SCALPER";
    PlacedFrom[PlacedFrom["HOT_BUTTON"] = 18] = "HOT_BUTTON";
    PlacedFrom[PlacedFrom["CHART_VISUAL_DB_CLICK"] = 19] = "CHART_VISUAL_DB_CLICK";
    PlacedFrom[PlacedFrom["TRADINGSYSTEMLIST"] = 20] = "TRADINGSYSTEMLIST";
    PlacedFrom[PlacedFrom["MATRIX_OE"] = 21] = "MATRIX_OE";
    PlacedFrom[PlacedFrom["MAM_OE"] = 22] = "MAM_OE";
    // = 23, Desktop =Console События из созданной консоли панели Trading status list
    PlacedFrom[PlacedFrom["LADDER_VIEW"] = 24] = "LADDER_VIEW";
    PlacedFrom[PlacedFrom["LADDER_VIEW_OE"] = 25] = "LADDER_VIEW_OE";
    PlacedFrom[PlacedFrom["TRADING_IDEA_CARD"] = 26] = "TRADING_IDEA_CARD";
    PlacedFrom[PlacedFrom["PORTFOLIO_MANAGER"] = 27] = "PORTFOLIO_MANAGER";
    PlacedFrom[PlacedFrom["POSITIONS_PANEL_CONTEXT_MENU"] = 28] = "POSITIONS_PANEL_CONTEXT_MENU";
    PlacedFrom[PlacedFrom["ORDERS_PANEL_CONTEXT_MENU"] = 29] = "ORDERS_PANEL_CONTEXT_MENU";
    PlacedFrom[PlacedFrom["CHART_VISUAL_CONTEXT_MENU"] = 30] = "CHART_VISUAL_CONTEXT_MENU";
    PlacedFrom[PlacedFrom["WEB_CHART_OE"] = 50] = "WEB_CHART_OE";
    PlacedFrom[PlacedFrom["WEB_CHART_VISUAL"] = 51] = "WEB_CHART_VISUAL";
    PlacedFrom[PlacedFrom["WEB_CHART_VISUAL_DB_CLICK"] = 52] = "WEB_CHART_VISUAL_DB_CLICK";
    PlacedFrom[PlacedFrom["WEB_MARKETDEPTH"] = 53] = "WEB_MARKETDEPTH";
    PlacedFrom[PlacedFrom["WEB_OE"] = 54] = "WEB_OE";
    // WEB_FXBOARD = 55, // same as 5
    PlacedFrom[PlacedFrom["WEB_OPTION_MASTER"] = 56] = "WEB_OPTION_MASTER";
    PlacedFrom[PlacedFrom["WEB_ORDERS_PANEL_HOT_BTN"] = 57] = "WEB_ORDERS_PANEL_HOT_BTN";
    PlacedFrom[PlacedFrom["WEB_ORDERS_PANEL_DB_CLICK"] = 58] = "WEB_ORDERS_PANEL_DB_CLICK";
    PlacedFrom[PlacedFrom["WEB_POSITIONS_PANEL_HOT_BTN"] = 59] = "WEB_POSITIONS_PANEL_HOT_BTN";
    PlacedFrom[PlacedFrom["WEB_POSITIONS_PANEL_DB_CLICK"] = 60] = "WEB_POSITIONS_PANEL_DB_CLICK";
    PlacedFrom[PlacedFrom["WEB_PORTFOLIO_MANAGER"] = 61] = "WEB_PORTFOLIO_MANAGER";
    PlacedFrom[PlacedFrom["WEB_CHART_VISUAL_CONTEXT_MENU"] = 62] = "WEB_CHART_VISUAL_CONTEXT_MENU";
    PlacedFrom[PlacedFrom["WEB_ORDERS_PANEL_CONTEXT_MENU"] = 63] = "WEB_ORDERS_PANEL_CONTEXT_MENU";
    PlacedFrom[PlacedFrom["WEB_POSITIONS_PANEL_CONTEXT_MENU"] = 64] = "WEB_POSITIONS_PANEL_CONTEXT_MENU";
    PlacedFrom[PlacedFrom["WEB_SAVED_ORDERS"] = 65] = "WEB_SAVED_ORDERS";
    PlacedFrom[PlacedFrom["MOB_CHART_OE"] = 70] = "MOB_CHART_OE";
    PlacedFrom[PlacedFrom["MOB_WL_OE"] = 71] = "MOB_WL_OE";
    PlacedFrom[PlacedFrom["MOB_MARKETDEPTH"] = 72] = "MOB_MARKETDEPTH";
    PlacedFrom[PlacedFrom["MOB_ORDERS_HOT_BTN"] = 73] = "MOB_ORDERS_HOT_BTN";
    PlacedFrom[PlacedFrom["MOB_POSITIONS_HOT_BTN"] = 74] = "MOB_POSITIONS_HOT_BTN";
    PlacedFrom[PlacedFrom["MOB_TAB_CHART_VISUAL_HOT_BTN"] = 75] = "MOB_TAB_CHART_VISUAL_HOT_BTN";
    PlacedFrom[PlacedFrom["MOB_CANCEL_ALL_ORDERS"] = 76] = "MOB_CANCEL_ALL_ORDERS";
    PlacedFrom[PlacedFrom["MOB_CLOSE_ALL_POSITIONS"] = 77] = "MOB_CLOSE_ALL_POSITIONS";
    PlacedFrom[PlacedFrom["MOB_OTHER"] = 78] = "MOB_OTHER";
    PlacedFrom[PlacedFrom["MOB_PORTFOLIO_MANAGER"] = 79] = "MOB_PORTFOLIO_MANAGER";
    PlacedFrom[PlacedFrom["MOB_CHART_VISUAL_TRADING"] = 80] = "MOB_CHART_VISUAL_TRADING";
    PlacedFrom[PlacedFrom["MOB_TRADING_IDEAS"] = 81] = "MOB_TRADING_IDEAS";
    PlacedFrom[PlacedFrom["MOB_INVESTING_CHART_OE"] = 82] = "MOB_INVESTING_CHART_OE";
    PlacedFrom[PlacedFrom["MOB_INVESTING_WATCHLIST_OPTION_OE"] = 83] = "MOB_INVESTING_WATCHLIST_OPTION_OE";
    PlacedFrom[PlacedFrom["MOB_INVESTING_ASSETS_SELL_ASSET"] = 84] = "MOB_INVESTING_ASSETS_SELL_ASSET";
    PlacedFrom[PlacedFrom["MOB_INVESTING_POSITIONS_INCREASE"] = 85] = "MOB_INVESTING_POSITIONS_INCREASE";
    PlacedFrom[PlacedFrom["MOB_INVESTING_CANCEL_ORDERS"] = 86] = "MOB_INVESTING_CANCEL_ORDERS";
    PlacedFrom[PlacedFrom["MOB_INVESTING_CLOSE_POSITIONS"] = 87] = "MOB_INVESTING_CLOSE_POSITIONS";
    PlacedFrom[PlacedFrom["MOB_INVESTING_TRADING_IDEAS"] = 88] = "MOB_INVESTING_TRADING_IDEAS";
    PlacedFrom[PlacedFrom["MOB_INVESTING_OTHER"] = 89] = "MOB_INVESTING_OTHER";
    PlacedFrom[PlacedFrom["MOB_INVESTING_OE"] = 90] = "MOB_INVESTING_OE";
    PlacedFrom[PlacedFrom["CLOSE_ALL_ORDERS"] = 97] = "CLOSE_ALL_ORDERS";
    PlacedFrom[PlacedFrom["CLOSE_ALL_POSITIONS"] = 98] = "CLOSE_ALL_POSITIONS";
    PlacedFrom[PlacedFrom["WEB_OTHER"] = 100] = "WEB_OTHER";
    PlacedFrom[PlacedFrom["SERVER_OTHER"] = 101] = "SERVER_OTHER";
    PlacedFrom[PlacedFrom["REST"] = 102] = "REST";
    PlacedFrom[PlacedFrom["DESKTOP_ALERT"] = 105] = "DESKTOP_ALERT";
    PlacedFrom[PlacedFrom["WEB_ALERT"] = 106] = "WEB_ALERT";
    PlacedFrom[PlacedFrom["MAC_ALERT"] = 107] = "MAC_ALERT";
    PlacedFrom[PlacedFrom["ANDROID_ALERT"] = 108] = "ANDROID_ALERT";
    PlacedFrom[PlacedFrom["IOS_ALERT"] = 109] = "IOS_ALERT";
    PlacedFrom[PlacedFrom["MOB_OPTIONS_PANEL"] = 110] = "MOB_OPTIONS_PANEL";
    PlacedFrom[PlacedFrom["AUTO_INVEST_MOB_ANDROID"] = 122] = "AUTO_INVEST_MOB_ANDROID";
    PlacedFrom[PlacedFrom["AUTO_INVEST_MOB_IOS"] = 123] = "AUTO_INVEST_MOB_IOS";
    PlacedFrom[PlacedFrom["AUTO_INVEST_MOB_WEB"] = 124] = "AUTO_INVEST_MOB_WEB";
    PlacedFrom[PlacedFrom["AUTO_INVEST_DESKTOP"] = 125] = "AUTO_INVEST_DESKTOP";
    PlacedFrom[PlacedFrom["AUTO_INVEST_WEB"] = 126] = "AUTO_INVEST_WEB";
    PlacedFrom[PlacedFrom["AUTO_INVEST_MOB_INV_ANDROID"] = 127] = "AUTO_INVEST_MOB_INV_ANDROID";
    PlacedFrom[PlacedFrom["AUTO_INVEST_MOB_INV_IOS"] = 128] = "AUTO_INVEST_MOB_INV_IOS";
    PlacedFrom[PlacedFrom["REST_API_AUTO_INVEST"] = 129] = "REST_API_AUTO_INVEST";
    PlacedFrom[PlacedFrom["WEB_MOB_CHART_OE"] = 151] = "WEB_MOB_CHART_OE";
    PlacedFrom[PlacedFrom["WEB_MOB_WL_OE"] = 152] = "WEB_MOB_WL_OE";
    PlacedFrom[PlacedFrom["WEB_MOB_MARKETDEPTH"] = 153] = "WEB_MOB_MARKETDEPTH";
    PlacedFrom[PlacedFrom["WEB_MOB_ORDERS_HOT_BTN"] = 154] = "WEB_MOB_ORDERS_HOT_BTN";
    PlacedFrom[PlacedFrom["WEB_MOB_POSITIONS_HOT_BTN"] = 155] = "WEB_MOB_POSITIONS_HOT_BTN";
    PlacedFrom[PlacedFrom["WEB_MOB_CANCEL_ORDER"] = 156] = "WEB_MOB_CANCEL_ORDER";
    PlacedFrom[PlacedFrom["WEB_MOB_CLOSE_POSITION"] = 157] = "WEB_MOB_CLOSE_POSITION";
    PlacedFrom[PlacedFrom["WEB_MOB_OTHER"] = 158] = "WEB_MOB_OTHER";
    PlacedFrom[PlacedFrom["WEB_MOB_CHART_VISUAL_TRADING"] = 159] = "WEB_MOB_CHART_VISUAL_TRADING";
    PlacedFrom[PlacedFrom["WEB_MOB_TRADING_IDEAS"] = 160] = "WEB_MOB_TRADING_IDEAS";
    PlacedFrom[PlacedFrom["WEB_MOB_ALERTS"] = 161] = "WEB_MOB_ALERTS";
    PlacedFrom[PlacedFrom["TV_TRADING_PLATFORM_OTHER"] = 180] = "TV_TRADING_PLATFORM_OTHER";
    PlacedFrom[PlacedFrom["TV_TRADING_PLATFORM_OE"] = 181] = "TV_TRADING_PLATFORM_OE";
    PlacedFrom[PlacedFrom["TV_TRADING_PLATFORM_DOM"] = 182] = "TV_TRADING_PLATFORM_DOM";
    PlacedFrom[PlacedFrom["CLIENT_API_WEBHOOK"] = 183] = "CLIENT_API_WEBHOOK";
    PlacedFrom[PlacedFrom["TV_TRADING_PLATFORM_POSITIONS"] = 184] = "TV_TRADING_PLATFORM_POSITIONS";
    PlacedFrom[PlacedFrom["TV_TRADING_PLATFORM_ORDER_PANEL"] = 185] = "TV_TRADING_PLATFORM_ORDER_PANEL";
    PlacedFrom[PlacedFrom["SERVER"] = 255] = "SERVER";
})(PlacedFrom || (PlacedFrom = {}));
